export const PART = 'componentPart'
export const DETAILS = 'componentDetails'
export const TYPE = 'componentType'